import { RESET_DATASET } from 'store';

import { SET_SELECTED_SAMPLE_ID } from './types';
import { RESET_BOOTSTRAP_CIS } from '../types';

export default (state = 0, action) => {
  switch (action.type) {
    case SET_SELECTED_SAMPLE_ID:
      return action.selectedSampleId;

    case RESET_DATASET:
    case RESET_BOOTSTRAP_CIS:
      return 0;

    default:
      return state;
  }
};
